import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../form-components/input/Button";

const OtpPage: React.FC = () => {
  const [otp, setOtp] = useState("");
  const [seconds, setSeconds] = useState(180);
  const [status, setStatus] = useState("idle");
  const [otpError, setOtpError] = useState("");

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds > 0) {
          return prevSeconds - 1;
        } else {
          clearInterval(interval);
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  const handleOtpSubmit = async () => {
    if (!otp) {
      setOtpError("Please enter otp");
    }

    try {
      setStatus("loading");
      const response = await fetch(
        "https://backend-kyw8.onrender.com/verify-2fa",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ code: otp, email: location?.state?.email }),
        }
      );

      if (!response.ok) {
        toast.error("Something went wrong, please try again!!!", {
          position: "bottom-right",
        });
        setStatus("fail");
      } else {
        await response.json();
        toast.success(`Otp verified successfully`, {
          position: "bottom-right",
        });
        navigate("/login");
        setStatus("success");
        setOtp("");
        setOtpError("");
      }
    } catch (error) {
      console.log(error);
      setStatus("fail");
    }
  };

  return (
    <div className="main-div">
      <div className="form-div !max-w-fit flex flex-col gap-6 border border-[#222222] rounded-[20px]">
        <h2 className="text-black font-semibold text-3xl text-center">
          Enter Verification Code
        </h2>
        <div>
          <p className="text-[#8b8989] font-normal text-base text-center">
            We&apos;ve sent you an OTP to your registered email address
          </p>
          <p className="text-[#8b8989] font-normal text-base text-center">
            This code will expire in{" "}
            <span className="text-black">{formatTime(seconds)}s</span>
          </p>
        </div>
        <div>
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={(index) => <span key={`sep-${index}`}>-</span>}
            renderInput={(props, index) => (
              <input
                {...props}
                key={`otp-${index}`}
                className="border border-[#a9a9a9] !w-1/2 md:!w-[80px] !h-[80px] rounded-[8px] focus:border-black"
              />
            )}
          />
          {otpError && <span className="text-[red] text-sm">{otpError}</span>}
        </div>

        <Button
          isLoading={status === "loading"}
          disabled={!otp || seconds === 0}
          buttonText="Verify OTP"
          onClick={handleOtpSubmit}
        />
      </div>
    </div>
  );
};

export default OtpPage;
